import { protectRoute } from 'components/route-access/route-access'
import React from 'react'
import BnkWarehouseLocationCreatePage from 'domains/bnk-warehouse-location/pages/bnk-warehouse-location-create-page/bnk-warehouse-location-create-page'
import BnkWarehouseLocationListPage from 'domains/bnk-warehouse-location/pages/bnk-warehouse-location-list-page/bnk-warehouse-location-list-page'
import BnkWarehouseLocationEditPage from 'domains/bnk-warehouse-location/pages/bnk-warehouse-location-edit-page/bnk-warehouse-location-edit-page'
import Phase3AuditLogPage from 'domains/phase3-inbound-journey/pages/Phase3AuditLogPage'
import LegacySettingsResourcePage from 'domains/setting/pages/legacy-resource-page'
import { LEGACY_SETTINGS_RESOURCES } from 'domains/setting/constants/legacy-settings-resources'
import BannerPage from 'domains/setting/pages/banner-page'
import AppointmentPage from 'domains/setting/pages/appointment-page'
import AdministratorPage from 'domains/setting/pages/administrator-page'
import MigrationReportsPage from 'domains/dashboard-migration/reports-page'
import BankPage from 'domains/setting/pages/bank-page/bank-page'

const SETTINGS_DELEGATED_EMAILS = [ 'rahayu@belleandkate.com', 'angel@belleandkate.com', 'jac@belleandkate.com', 'putri@belleandkate.com' ]

const legacySettingRoute = ({ resourceKey, path, miniName, allowedEmails }) => {
  const config = LEGACY_SETTINGS_RESOURCES[resourceKey]

  return {
    path,
    name         : config.title,
    miniName,
    allowedRoles : config.allowedRoles,
    allowedEmails,
    component    : (props) => <LegacySettingsResourcePage { ...props } resourceKey={ resourceKey } />,
    layout       : '/app'
  }
}

const setting_routes = {
  collapse  : true,
  path      : '/setting',
  name      : 'Setting',
  icon      : 'fas fa-cog text-gray',
  state_key : 'setting_collapse',
  views     : [
    {
      path: '/setting/banks',
      name: 'Bank',
      miniName: 'BK',
      allowedRoles: [ 'owner', 'admin', 'purchasing' ],
      allowedEmails: SETTINGS_DELEGATED_EMAILS,
      component: BankPage,
      layout: '/app'
    },
    {
      path: '/setting/reportings',
      name: 'Reportings',
      miniName: 'RE',
      allowedRoles: [ 'owner', 'finance', 'admin' ],
      allowedEmails: [ 'mifta.belleandkate@gmail.com', 'sweta.sabilillah.belleandkate@gmail.com' ],
      component: MigrationReportsPage,
      layout: '/app'
    },
    {
      path      : '/all-team/audit-log',
      name      : 'Audit Log',
      miniName  : 'AL',
      allowedRoles: [ 'owner', 'admin', 'finance' ],
      allowedEmails: [ 'angel@belleandkate.com', 'jac@belleandkate.com', 'rahayu@belleandkate.com' ],
      component : (props) => <Phase3AuditLogPage { ...props } mainTitle='Setting' subTitle='Audit Log' />,
      layout    : '/app'
    },
    {
      path      : '/warehouse-team/location/list-page',
      name      : 'Location Master',
      miniName  : 'LM',
      component : BnkWarehouseLocationListPage,
      layout    : '/app'
    },
    {
      path      : '/warehouse-team/location/create-page',
      name      : 'Create Location Master',
      miniName  : 'CreLM',
      component : BnkWarehouseLocationCreatePage,
      layout    : '/app',
      invisible : true
    },
    {
      path      : '/warehouse-team/location/:id(\\d+)',
      name      : 'Edit Location Master',
      miniName  : 'EditLM',
      component : BnkWarehouseLocationEditPage,
      layout    : '/app',
      invisible : true
    },
    legacySettingRoute({ resourceKey: 'colours', path: '/setting/colours', miniName: 'CO' }),
    legacySettingRoute({ resourceKey: 'currencies', path: '/setting/currencies', miniName: 'CU', allowedEmails: SETTINGS_DELEGATED_EMAILS }),
    legacySettingRoute({ resourceKey: 'groups', path: '/setting/groups', miniName: 'GR' }),
    legacySettingRoute({ resourceKey: 'stores', path: '/setting/stores', miniName: 'ST' }),
    legacySettingRoute({ resourceKey: 'designers', path: '/setting/designers', miniName: 'DE' }),
    legacySettingRoute({ resourceKey: 'badges', path: '/setting/badges', miniName: 'BA', allowedEmails: SETTINGS_DELEGATED_EMAILS }),
    legacySettingRoute({ resourceKey: 'job_openings', path: '/setting/job-openings', miniName: 'JO' }),
    {
      path         : '/setting/banners',
      name         : 'Banners',
      miniName     : 'BN',
      allowedRoles : [ 'owner', 'admin' ],
      allowedEmails: SETTINGS_DELEGATED_EMAILS,
      component    : BannerPage,
      layout       : '/app'
    },
    {
      path         : '/setting/appointments',
      name         : 'Appointments',
      miniName     : 'AP',
      allowedRoles : [ 'owner', 'admin' ],
      allowedEmails: SETTINGS_DELEGATED_EMAILS,
      component    : AppointmentPage,
      layout       : '/app'
    },
    {
      path         : '/setting/administrators',
      name         : 'Administrators',
      miniName     : 'AD',
      allowedRoles : [ 'owner' ],
      component    : AdministratorPage,
      layout       : '/app'
    }
  ]
}

export default { ...setting_routes, views: setting_routes.views.map(protectRoute) }
